module.exports = __webpack_public_path__ + "static/img/img06-04.f77d955.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c37/img06-04.png
// module id = 6OTE
// module chunks = 0